<template>
    <div v-if="showTotalPerPage && totalRecords > 0">
        <ul class="pagination-list">
            <li v-for="opt in filteredOptions" :key="opt">
                <button class="pagination-pill" :class="{ 'is-selected': value === opt }" type="button"
                    @click="select(opt)">
                    {{ opt }}
                </button>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
    name: "PaginationPerPage",
    props: {
        totalRecords: { type: Number, default: 0 },
        showTotalPerPage: { type: Boolean, default: true },
    },
    data() {
        return {
            value: 10,
            options: [10, 20, 50, 100],
        };
    },
    computed: {
        ...mapState("generic", ["paginations"]),
        filteredOptions() {
            const total = this.totalRecords;

            if (total <= 10) return [10];
            if (total <= 20) return [10, 20];
            if (total <= 50) return [10, 20, 50];
            if (total <= 100) return [10, 20, 50, 100];
            return this.options;
        },
    },
    created() {
        const fromStore = Number(this.paginations?.totalPerPage);
        if (Number.isFinite(fromStore)) {
            this.value = fromStore;
        }
        this.updateTotalPerPage({ content: String(this.value), id: this.value });
    },
    methods: {
        ...mapMutations("generic", ["executedSearch", "updateTotalPerPage"]),
        select(opt) {
            if (this.value === opt) return;
            this.value = opt;
            this.updateTotalPerPage({ content: String(opt), id: opt });
            this.executedSearch();
        },
    },
    watch: {
        totalRecords() {
            if (this.totalRecords <= 0) return;
            if (!this.filteredOptions.includes(this.value)) {
                const next = this.filteredOptions[this.filteredOptions.length - 1];
                this.value = next;
                this.updateTotalPerPage({ content: String(next), id: next });
            }
        },
    },
};
</script>

<style scoped>
.pagination-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    width: 100%;
    font-family: inherit;
}

.pagination-list {
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 0;
    padding: 0;
    list-style: none;
}

.pagination-pill {
    width: 31px;
    height: 31px;
    border-radius: 50%;
    background: #f5f5f5;
    border: none;
    color: #444;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s, color 0.2s, transform 0.1s;
}

.pagination-pill:hover {
    background: #e0e0e0;
}

.pagination-pill.is-selected {
    background: #D98621;
    color: #fff;
}

.pagination-pill:active {
    transform: scale(0.95);
}
</style>
